import { usePreQuestions } from "@/components/features/items/edit/_shared/ui/components/main/questions/pre-question/hooks";

import { useProductPlanI18nFormModelContext } from "../../../../../context";

export const usePlanPreQuestions = () => {
	const { viewModel, onSetViewModel } = useProductPlanI18nFormModelContext();
	const { questions } = viewModel;

	return {
		...usePreQuestions({ questions, onSetViewModel }),
	};
};
